module.exports = __webpack_public_path__ + "img/224.6602319a.jpg";